import type { PublicSlotKey } from '@/apilib';
import type { TextClassificationApi } from './textClassificationApi';

export const TextClassificationApiKey: PublicSlotKey<TextClassificationApi> = {
  name: 'TextClassificationApi',
  public: true,
};
